import type { CategoryGuid } from '@atlassian/jira-servicedesk-knowledge-services/src/types.tsx';

export const UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE =
	'state.actions.update-categories-for-article-failure.UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE' as const;

export type UpdateCategoriesForArticleFailure = {
	articleId: string;
	failedCategoryIds: CategoryGuid[];
	errorKey: string;
	errorMessage: string;
	statusCode: number;
};

export type UpdateCategoriesForArticleFailureAction = {
	type: typeof UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE;
	payload: UpdateCategoriesForArticleFailure;
};

export const updateCategoriesForArticleFailure = (
	payload: UpdateCategoriesForArticleFailure,
): UpdateCategoriesForArticleFailureAction => ({
	payload,
	type: UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE,
});
